import React, { useState, useEffect } from 'react'
import {
	Box,
	Tag,
	Image,
	Text,
	Flex,
	IconButton,
	Avatar,
	HStack,
} from '@chakra-ui/react'
import { getCurrentDateUTC, formatHHMM } from '../../../../utils/date.utils'
import { downloadAwsFile, loadAwsFile } from '../../../../utils/aws.util'
import { BsDownload } from 'react-icons/bs'
import excel from '../../../../assets/images/excel.png'
import pdf from '../../../../assets/images/pdf.png'
import word from '../../../../assets/images/word.png'
import text from '../../../../assets/images/text.jpg'

const SingleMessage = ({ messages, user, index, chanelName, profileImage }) => {
	const [imageData, setImageData] = useState('')
	const [imageType, setImagetype] = useState('')
	const convertUnicode = input => {
		return input.replace(/\\u(\w{4,4})/g, function (a, b) {
			var charcode = parseInt(b, 16)
			return String.fromCharCode(charcode)
		})
	}

	const onImgDownload = async attachments => {
		await Promise.all(
			attachments.map(async val => {
				await downloadAwsFile(val)
			})
		)
	}

	const toReturnName = url => {
		return url.split('/').pop()
	}

	let isHasAttachment = (
		typeof messages?.data_entity_inline === 'string'
			? JSON.parse(messages?.data_entity_inline || '')
			: messages?.data_entity_inline
	).attachments

	let attachmentData = isHasAttachment?.length
		? toReturnName(isHasAttachment[0])
		: ''

	useEffect(() => {
		setTimeout(() => {
			if (!!isHasAttachment && isHasAttachment?.length > 0) {
				let type = isHasAttachment[0]?.split('.')?.pop()

				setImagetype(type)
				if (type?.toLowerCase() === 'pdf') {
					setImageData(pdf)
				} else if (
					type?.toLowerCase() === 'xls' ||
					type?.toLowerCase() === 'xlsx' ||
					type?.toLowerCase() === 'csv'
				) {
					setImageData(excel)
				} else if (type?.toLowerCase() === 'docx') {
					setImageData(word)
				} else if (type?.toLowerCase() === 'txt') {
					setImageData(text)
				}
				// else if (
				//   type?.toLowerCase() === 'mp4' ||
				//   type?.toLowerCase() === 'mp3'
				// ) {
				//   setImageData(isHasAttachment[0])
				// }
				else {
					loadAwsFile(isHasAttachment[0], d => {
						let imagedata = 'data:' + d.type + ';base64,' + d.data
						setImageData(imagedata)
					})
				}
			}
		}, 1000)
	})
	return (
		<Box marginBottom='8'>
			{Object.keys(
				typeof messages?.data_entity_inline === 'string'
					? JSON.parse(messages?.data_entity_inline || '')
					: messages?.data_entity_inline
			).length > 0 ? (
				Number(messages?.asset_id) === user?.asset_id ? (
					<Box
						style={{ position: 'relative', marginBottom: '20px' }}
						className={`timeline-message-all-type `}
						width='50%'
						ml='50%'
					>
						<Box style={{ display: 'flex', flexDirection: 'row-reverse' }}>
							<Tag
								paddingY='1'
								bg='brand.700'
								fontSize='14px'
								padding='12px 16px'
								borderRadius='15px 15px 0px 15px'
								mr='10px'
								display='flex'
								alignItems='end'
								flexDirection={!!isHasAttachment.length && 'column'}
							>
								{imageType?.toLowerCase() === 'pdf' ||
								imageType?.toLowerCase() === 'xls' ||
								imageType?.toLowerCase() === 'txt' ||
								imageType?.toLowerCase() === 'xlsx' ||
								imageType?.toLowerCase() === 'docx' ||
								imageType?.toLowerCase() === 'csv' ? (
									<Box display='flex' bg='#FFFFFF' borderRadius='10px'>
										{imageData && (
											<Image
												src={imageData}
												h='35px'
												w='31px'
												borderRadius='10px'
											/>
										)}
										<Tag
											fontSize='14px'
											color='#000000'
											fontWeight='400'
											fontStyle='normal'
											dangerouslySetInnerHTML={{
												__html: !attachmentData
													? convertUnicode(
															unescape(
																(typeof messages?.data_entity_inline ===
																'string'
																	? JSON.parse(
																			messages?.data_entity_inline || ''
																	  )
																	: messages?.data_entity_inline
																).content
															)
													  )
													: attachmentData,
											}}
										/>
										{!!isHasAttachment.length && (
											<IconButton
												variant=''
												color='brand.700'
												aria-label='See menu'
												cursor='pointer'
												size='md'
												onClick={() => onImgDownload(isHasAttachment)}
												icon={<BsDownload size='20' />}
											/>
										)}
									</Box>
								) : (
									<Box display='flex'>
										{imageData &&
											(imageType?.toLowerCase() === 'mp4' ? (
												<video controls style={{ width: '250px' }}>
													<source src={imageData} type='video/mp4' />
												</video>
											) : imageType?.toLowerCase() === 'mp3' ? (
												<Text>
													<audio controls style={{ width: '250px' }}>
														<source src={imageData} type='audio/mp3' />
													</audio>
												</Text>
											) : (
												<>
													<Image src={imageData} h='200px' w='200px' ml='2' />
												</>
											))}
										{imageData && (
											<IconButton
												variant=''
												color='#FFFFFF'
												aria-label='See menu'
												cursor='pointer'
												size='md'
												onClick={() => onImgDownload(isHasAttachment)}
												icon={<BsDownload size='20' />}
											/>
										)}
									</Box>
								)}
								<Box>
									<Tag
										bg='brand.700'
										fontSize='14px'
										color='#FFFFFF'
										fontWeight='400'
										fontStyle='normal'
										dangerouslySetInnerHTML={{
											__html: convertUnicode(
												unescape(
													(typeof messages?.data_entity_inline === 'string'
														? JSON.parse(messages?.data_entity_inline || '')
														: messages?.data_entity_inline
													).content
												)
											),
										}}
									/>
								</Box>
								<Text
									color='#FFFFFF'
									fontWeight='400'
									fontStyle='normal'
									fontSize='12px'
									mt='5px'
								>
									{formatHHMM(messages?.datetime_log || getCurrentDateUTC())}
								</Text>
							</Tag>
						</Box>
					</Box>
				) : (
					<Box
						style={{
							position: 'relative',
							marginBottom: '20px',
							marginLeft: '10px',
						}}
						className={`timeline-message-all-type`}
						width='50%'
					>
						<Box style={{ display: 'flex' }}>
							<Image src={profileImage} h='30px' w='30px' borderRadius='50%' />

							<Flex flexDir='column' ml='5px'>
								<Text fontSize='14px' color='#646464' fontWeight='400'>
									{messages?.operating_asset_first_name}
								</Text>

								<Box
									paddingY='1'
									bg='#FFFFFF'
									fontSize='14px'
									padding='12px 16px'
									borderRadius='0px 12px 12px 12px'
									mr='10px'
									display='flex'
									alignItems='end'
									position='relative'
									flexDirection={!!isHasAttachment.length && 'column'}
								>
									{imageType?.toLowerCase() === 'pdf' ||
									imageType?.toLowerCase() === 'xls' ||
									imageType?.toLowerCase() === 'xlsx' ||
									imageType?.toLowerCase() === 'txt' ||
									imageType?.toLowerCase() === 'docx' ||
									imageType?.toLowerCase() === 'csv' ? (
										<Box display='flex' bg='#F5F5F5' borderRadius='10px'>
											{imageData && !!isHasAttachment.length && (
												<>
													<Image
														src={imageData}
														h='35px'
														w='31px'
														borderRadius='10px'
													/>
												</>
											)}
											{!!isHasAttachment.length && (
												<>
													<Tag
														//bg='#FFFFFF'
														fontSize='14px'
														color='#646464'
														fontWeight='400'
														fontStyle='normal'
														dangerouslySetInnerHTML={{
															__html: !attachmentData
																? convertUnicode(
																		unescape(
																			(typeof messages?.data_entity_inline ===
																			'string'
																				? JSON.parse(
																						messages?.data_entity_inline || ''
																				  )
																				: messages?.data_entity_inline
																			).content
																		)
																  )
																: attachmentData,
														}}
													/>
													<IconButton
														variant=''
														color='brand.700'
														aria-label='See menu'
														cursor='pointer'
														size='md'
														onClick={() => onImgDownload(isHasAttachment)}
														icon={<BsDownload size='20' />}
													/>
												</>
											)}
										</Box>
									) : (
										<Box display='flex'>
											{imageData &&
												(imageType?.toLowerCase() === 'mp4' ? (
													<video controls style={{ width: '250px' }}>
														<source src={imageData} type='video/mp4' />
													</video>
												) : imageType?.toLowerCase() === 'mp3' ? (
													<Text>
														<audio controls style={{ width: '250px' }}>
															<source src={imageData} type='audio/mp3' />
														</audio>
													</Text>
												) : (
													<>
														<Image src={imageData} h='200px' w='200px' ml='2' />
													</>
												))}
											{imageData && (
												<IconButton
													variant=''
													color='brand.700'
													aria-label='See menu'
													cursor='pointer'
													size='md'
													onClick={() => onImgDownload(isHasAttachment)}
													icon={<BsDownload size='20' />}
												/>
											)}
										</Box>
									)}
									<Tag
										bg='#FFFFFF'
										fontSize='14px'
										color='#646464'
										fontWeight='400'
										fontStyle='normal'
										dangerouslySetInnerHTML={{
											__html: !attachmentData
												? convertUnicode(
														unescape(
															(typeof messages?.data_entity_inline === 'string'
																? JSON.parse(messages?.data_entity_inline || '')
																: messages?.data_entity_inline
															).content
														)
												  )
												: attachmentData,
										}}
									/>

									<Text
										color='#646464'
										fontWeight='400'
										fontStyle='normal'
										fontSize='12px'
										mt='5px'
									>
										{formatHHMM(messages?.datetime_log || getCurrentDateUTC())}
									</Text>
								</Box>
							</Flex>
						</Box>
					</Box>
				)
			) : null}
		</Box>
	)
}

export default SingleMessage
